export default __webpack_public_path__ + "static/laser_engraving1-0d2b729678644d7fc04cc693c19d009a.jpg";